import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Button } from '@sendible/design-system';

import './scss/index.scss';

function HeaderSection(props) {
  const {
    title,
    supportPopoverContent,
  } = props;

  return (
    <div className="title-container">
      <span>{title}</span>
      <div className="profiles">
        <Popover
          content={supportPopoverContent}
          placement="top"
          useClick
        >
          <Button
            appearance="default"
            darkmode
            icon="info"
            label=""
            size={12}
            variation="default"
          />
        </Popover>
      </div>
    </div>
  );
}

HeaderSection.propTypes = {
  title: PropTypes.string.isRequired,
  supportPopoverContent: PropTypes.node.isRequired,
};

export default HeaderSection;
